import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Box, Grid, Typography, Button, Dialog, DialogContent, IconButton, DialogActions, Card, FormControlLabel
} from '@material-ui/core';
import CustomPoper from '../CustomizedUIs/CustomPoper';
import CustomMessagePoper from './custom-message-popover';
import { makeStyles } from '@material-ui/core';
import { useTranslate, useDataProvider } from 'react-admin';
import Field from '../CustomizedUIs/CustomTextFiled';
import TimePicker from '../common/TimePicker'
import moment from 'moment-timezone';
// Icons
import { Close } from '@material-ui/icons';
import TextButton from '../CustomizedUIs/TextButton';
import CloseButton from '../CustomizedUIs/CloseButton';

const useStyles = makeStyles(theme => ({
  dialogPaper: {
    minHeight: '60vh',
    maxHeight: '60vh',
    maxWidth: '650px',
    backgroundColor: theme.palette.background.default
  },
  dialogContent: {
    padding: '8px 40px'
  },
  list: {
    height: 255,
    backgroundColor: theme.palette.background.paper,
    overflow: 'auto',
  },
  button: {
    margin: theme.spacing(0.5, 0),
  },
  dialogCloseBtn: {
    // backgroundColor: theme.palette.common.white,
    marginLeft: 7,
    width: "25px",
    height: "25px",
    borderRadius: "10px",
    border: "solid 2px #e5f1f8",
    backgroundColor: " #ffffff",

  },
  boxBoder: {
    borderBottom: '1px solid',
    borderRight: '1px solid',
    borderBottomColor: theme.palette.grey['200'],
    borderRightColor: theme.palette.grey['200'],
  },
  input: {
    backgroundColor: 'white',
    borderRadius: '2px',
    "&:hover": {
      backgroundColor: 'white'
    },
    fontFamily: 'UniviaPro',
    fontSize: '13px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.85,
    letterSpacing: ' 0.13px',
    color: '#88898c',
  },
  inputMulti: {
    width: 525,
    borderRadius: '2px',
  },
  inputPopper: {
    alignSelf: 'flex-end',
    position: 'absolute',
    right: '16px',
    top: '20px'
  },
  send: {
    marginRight: '30px',
    width: '138px',
    height: '36px',
  },
  dialogActions: {
    paddingLeft: 32,
    paddingRight: 35,
    bottom: 0,
    right: 0,
  },
  divider: {
    marginTop: '14px'
  },
  btnClose: {
    fontFamily: " UniviaPro-Bold",
    fontSize: "10px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.4px",
    color: "#4f5064",
  },
  Title: {
    fontFamily: "UniviaPro-Medium",
    fontSize: "18px",
    fontWeight: 500,
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.2,
    letterSpacing: "normal",
    color: "#4f5064",
    paddingBottom: "30px",
    marginTop: -10
  },

  btnSave: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: ' 11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: theme.palette.primary.main,
  },
  btnSend: {
    fontFamily: 'UniviaPro-Bold',
    fontSize: ' 11px',
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: ' 0.44px',
    color: '#ffffff',
  },
  disable: {
    obacity: 0.4,
    pointerEvents: 'none',
    fontFamily: "UniviaPro",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.85,
    letterSpacing: " 0.13px",
    color: "#4f5064",
  },
  card: {
    marginTop: theme.spacing(1),
    borderRadius: 0,
    width: 200,
    height: 54,
    boxShadow: 'unset'
  },
  titleDateTime: {
    fontFamily: "UniviaPro",
    fontSize: 11,
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.36,
    letterSpacing: "normal",
    color: "#88898c",
  },
  TextDateTime: {
    fontFamily: "UniviaPro",
    fontSize: "13px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    lineHeight: 1.85,
    letterSpacing: " 0.13px",
    color: "#4f5064",
  },
}));
let oldDate = null;
function DialogEditScheduleMessage({ open, onClose, scheduleMessage = null, addMessage, index, isDate, setIsDate }) {
  const classes = useStyles();
  const translate = useTranslate();
  // STATE REGION
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [day, setDay] = useState('');
  const [date, setDate] = useState(new Date());
  const [time, setTime] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [openTimePickerStart, setOpenTimePickerStart] = useState(false);
  const [error, setError] = useState({
    subject: {
      isError: false,
      message: ""
    },
    message: {
      isError: false,
      message: ""
    },
    day: {
      isError: false,
      message: ""
    }
  });
  // END STATE REGION

  const textOnChange = prop => (e) => {
    switch (prop) {
      case 'subject':
        setSubject(e.target.value)
        break;
      case 'message':
        setMessage(e.target.value)
        break;
    }
    validate(prop, e.target.value)
  }

  const validate = (prop, value) => {
    if (value.length === 0)
      setError({
        ...error, [prop]: value.length === 0 ? {
          isError: true, message: translate('pos.messages.required')
        } : {
            isError: false, message: ''
          }
      })
    else {
      setError({
        ...error, [prop]: {
          isError: false, message: ''
        }
      })
    }
  }

  const handleClickOpenPoper = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClosePoper = () => {
    setAnchorEl(null);
  };

  const onSave = () => {
    const data = {
      subject,
      message,
      day,
      // hour: time.split(':').length > 0 ? time.split(':')[0] : 0,
      // minute: time.split(':').length > 0 ? time.split(':')[1] : 0,
      hour: new Date(date).getHours(),
      minute: new Date(date).getMinutes(),
    }
    if (scheduleMessage) {
      addMessage(data, index);
    } else {
      addMessage(data);
    }
    onClose();
    clearState();
  }

  const clearState = () => {
    setSubject('');
    setMessage('');
    setDay('');
    setTime('');
    setDate(new Date());
    setIsDate(false);
    setError({
      subject: {
        isError: false,
        message: ""
      },
      message: {
        isError: false,
        message: ""
      }
    })
  }

  const close = () => {
    clearState();
    onClose();
  }

  const disableCreateButton = () => {
    if (subject === '' || message === '' || day === '' || date === '') return true;
    if (scheduleMessage && parseInt(scheduleMessage.day) !== 0) {
      if (isDate === true && day + "" === '0')
        return true
    }
    if (!scheduleMessage) {
      if (isDate === true && day + "" === '0')
        return true
    }
    return false;
  }

  const onEnter = () => {
    if (scheduleMessage) {
      setSubject(scheduleMessage.subject);
      setMessage(scheduleMessage.message);
      setDay(scheduleMessage.day);
      if (scheduleMessage.day === 0) {
        setDate(new Date().setHours(0, 0, 0, 0))
      } else {
        setDate(new Date().setHours(scheduleMessage.hour, scheduleMessage.minute));
      }
    }
  }

  const onChangeDay = (value) => {
    value = value.replace(/^0+(?=\d)/g, '');
    if (value === '0') {
      setDate(new Date().setHours(0, 0, 0, 0))
    }
    setDay(value)
    validate('day', value)
  }

  const onOpenCalendar = (event) => {
    setAnchorEl(event.currentTarget);
    oldDate = date;
  }

  const onCloseCalendar = (event) => {
    setAnchorEl(null);
    setDate(oldDate);
  }

  const onChangeDate = (date) => {
    setDate(date);
    onFinishPickDate(date)
  }

  const onFinishPickDate = (date) => {
    setAnchorEl(null);
    setDate(date);
    oldDate = null;
  }

  const formatTime = (times) => {
    if (!times) {
      return '';
    }
    return moment(times).format('HH:mm');
  };

  const checkValidate = () => {
    if (scheduleMessage && parseInt(scheduleMessage.day) !== 0) {
      if (isDate === true && day + "" === '0')
        return true
    }
    if (!scheduleMessage) {
      if (isDate === true && day + "" === '0')
        return true
    }
    return false
  }

  const openPoper = anchorEl !== null;
  return (
    <Dialog open={open} fullWidth scroll='paper' classes={{ paper: classes.dialogPaper }} onEnter={onEnter}>
      <Box mx={5} mt={3}>
        <Box display='flex' justifyContent='flex-end' alignItems='center'>
          <Typography className={classes.btnClose}>{translate(`pos.user.close`)}</Typography>
            <CloseButton onClick={onClose} />
        </Box>
        {
          scheduleMessage ? <Typography className={classes.Title}>{translate(`resources.messages.editMessage`)}</Typography> :
            <Typography className={classes.Title}>{translate(`resources.messages.addMessage`)}</Typography>
        }
      </Box>
      <DialogContent className={classes.dialogContent}>
        <Box mx={2.5}>
          <Field
            onBlur={() => {
              validate('subject', subject)
            }}
            required
            id="subject"
            label={translate(`pos.messages.subject`)}
            value={subject}
            onChange={textOnChange('subject')}
            error={error.subject.message != "" && error.subject.isError}
            helperText={error.subject.message}
            style={{ width: 525 }}
            endDom={<CustomPoper
              open={openPoper}
              anchorEl={anchorEl}
              handleClick={handleClickOpenPoper}
              handleClose={handleClosePoper}
              title={translate(`pos.messages.subject`)}
              content={translate(`pos.messages.constentSubject`)}
              icon={<b>?</b>}
            />}
          />
        </Box>

        <Box mt={4.9} mx={2.5}>
          <Field
            onBlur={() => {
              validate('message', message)
            }}
            required
            className={classes.inputMulti}
            id="message"
            multiline
            rows={4}
            value={message}
            onChange={textOnChange('message')}
            error={error.message.message != "" && error.message.isError}
            helperText={error.message.message}
            placeholder={`${translate(`pos.messages.placeholder`)} *`}
            endDom={
              <Box>
                <Box className={classes.inputPopper}>
                  <CustomPoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`pos.messages.constent`)}
                    content={translate(`pos.messages.constentContent`)}
                    icon={<b>?</b>}
                  />
                </Box>
              </Box>
            }
          />
        </Box>
        <Box mt={2.5} mx={2.5}>
          <Box display="flex">
            <Box flex="2" >
              <Grid container spacing={1} alignItems="center" >
                <Grid item>
                  <Typography className={classes.titleRadio} color="textPrimary" >{translate(`pos.messages.day`)}</Typography>
                </Grid>
                <Grid item>
                  <CustomMessagePoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`pos.messages.day`)}
                    content={translate(`pos.messages.constentDay`)}
                    icon={<b>?</b>}
                  />
                </Grid>
              </Grid>
              <Field
                error={checkValidate()}
                helperText={checkValidate() ? translate(`pos.messages.isDate`) : ''}
                required
                id="day"
                type="number"
                value={day}
                onChange={e => onChangeDay(e.target.value)}
                style={{ width: 200, marginTop: 10 }}
              />
            </Box>
            <Box flex="1">
              <Grid container spacing={1} alignItems="center" >
                <Grid item>
                  <Typography className={classes.titleRadio} color="textPrimary" >{translate(`pos.messages.time`)}</Typography>
                </Grid>
                <Grid item>
                  <CustomMessagePoper
                    open={openPoper}
                    anchorEl={anchorEl}
                    handleClick={handleClickOpenPoper}
                    handleClose={handleClosePoper}
                    title={translate(`pos.messages.time`)}
                    content={translate(`pos.messages.constentTime`)}
                    icon={<b>?</b>}
                  />
                </Grid>
              </Grid>
              {/* <Field
                required
                disabled={day === '0'}
                id="time"
                type="time"
                value={time}
                onChange={e => setTime(e.target.value)}
                style={{ width: 200, marginTop: 10 }}
              /> */}
              <Card className={classes.card}>
                <FormControlLabel
                  classes={{ label: classes.titleDateTime }}
                  control={
                    <Box style={{ color: "black" }} ml={2} display="flex">
                      <Typography onClick={() => setOpenTimePickerStart(true)} className={((day + '' === '0' && isDate === true) || (day + '' === '0')) ? classes.disable : classes.TextDateTime}>{formatTime(date)}</Typography>
                    </Box>
                  }
                  // label={translate(`resources.severlog.Time`)}
                  style={{ marginTop: "27px", color: "#88898c" }}
                  labelPlacement="start"
                  variant="body2"
                />
                <TimePicker
                  openTimePicker={openTimePickerStart}
                  handleClick={onOpenCalendar}
                  setOpenTimePicker={setOpenTimePickerStart}
                  handleTimeChange={onChangeDate}
                  finishPickDate={onFinishPickDate}
                  value={moment(date).format('HH:mm')}
                  time={date}
                  hours
                />
              </Card>
            </Box>
          </Box>
        </Box>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <TextButton mr={2} style={{ marginTop: "1em" }} onClick={close}/>
         
        <Button
          disabled={disableCreateButton()}
          variant="contained"
          className={classes.send}
          size="large"
          color="primary"
          onClick={onSave}
        >
          <Typography className={classes.btnSend}>{translate('pos.common.save')}</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DialogEditScheduleMessage.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  scheduleMessage: PropTypes.object,
  addMessage: PropTypes.func.isRequired,
  index: PropTypes.number,
};

export default DialogEditScheduleMessage;
